<template>

	<section section class="col-xs-12 npd encuesta">

		<div class="col-xs-12 col-sm-6 obj-cont" v-for="encuesta in encuestas">
			<img v-if="encuesta.poll.image !== ''" v-bind:src="encuesta.poll.image" alt="" >
			<img v-else v-bind:src="theme_url+'/html/assets/img/encuesta.jpg'" alt="" >
		</div>

		<div class="col-xs-12 encuesta__wrp">
			<div class="container" v-for="encuesta in encuestas">
				<div class="row">
					<div class="col-xs-12 col-sm-6 float-right encuesta__datos">
						<h3>ENCUESTA</h3>
						<p>Tu opinion es muy importante</p>
						<h4>{{ encuesta.poll.question }}</h4>
						<form action="/wp-json/wp/v2/poll/" method="post" class="wp-polls-form" >

							<input type="hidden" name="action" value="polls">
							<input type="hidden" name="view" value="process">
							<input type="hidden" name="poll_id" v-bind:value="encuesta.poll.id">


							<div class="col-xs-12 col-md-6 input-item" v-for="rta in encuesta.poll.answers">
								<input type="radio" v-bind:name="'poll_'+encuesta.poll.id"  v-bind:id="'rta_'+rta.polla_qid+'_'+rta.polla_aid" v-bind:value="rta.polla_aid">
								<label @click="getEncuestas()" v-bind:for="'rta_'+rta.polla_qid+'_'+rta.polla_aid">{{ rta.polla_answers}}</label>
							</div>

						</form>
					</div>
				</div>
			</div>
			<a href="#" v-on:click.prevent="getEncuestas()" class="next">
				<i class="fa fa-chevron-right"></i>
			</a>
		</div>

	</section>

</template>



<script>
export default {

	props:[
		'post_id',
	],
	mounted: function() {
		const vm = this;
		vm.getEncuestas();
	},

	data() {
		return {
			base_path: rtwp.base_path,
			pageTitle: rtwp.site_name,
			theme_url:rtwp.theme_url,
			encuestas:[],
		};
	},
	methods: {
		getEncuestas: function() {
			const vm = this;
			// vm.$http.get( 'wp/v2/posts/?filter[category_slug]=podcasts&filter[meta_query][key]=enclosure')
			vm.$http.get( 'wp/v2/poll/')
			.then( ( res ) => {
				vm.encuestas = res.data;
				vm.loaded = 'true';
				console.log(vm.encuestas);
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${res}` );
			} );


		}
	}
};


</script>



// WEBPACK FOOTER //
// encuestasportada.vue?24f1ec2c